import * as React from 'react';
import * as mrCap from '../../mrCapTypes';
import * as api from '../../api/booking';
import { Input, TextArea, CheckBox } from '../payment/input';

interface Props {
  shops: mrCap.Shop[];
  gdprText: string;
}

interface State {
  callData: mrCap.CallData;
  consent: boolean;
  validError: boolean;
  finished: boolean;
}

export class CallWindow extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      callData: {
        name: '',
        phone: '',
        shopName: '',
        shopEmail: '',
        message: ''
      },
      consent: false,
      validError: false,
      finished: false
    };
  }

  resetError =() => {
    setTimeout(() => {
      this.setState({ validError: false });
    }, 2000);
  };

  async validateAndSend() {
    let validate = this.state;
    if (validate.callData.name !== '' &&
      validate.callData.shopEmail !== '' &&
      validate.callData.phone !== '' &&
      validate.consent) {
      try {
        await api.postCallData(this.state.callData);
        this.setState({ finished: true });
      } catch {
        // console.log('Something went wrong. Please try again.');
      }
    } else {
      this.setState({ validError: true });
      this.resetError();
    }
  };

  selectShop = (shopRef: string) => {
    const shopName = shopRef.split(',')[0];
    const shopEmail = shopRef.split(',')[1].replace(' ', '');
    this.setState({ callData: {...this.state.callData, shopName: shopName, shopEmail: shopEmail } });
  };

  render() {

    return (
      <div className='call-window-form'>
        {!this.state.finished
          ?<>
            <Row width={100}>
              <Input
                placeholder='För- och efternamn *'
                value={this.state.callData.name}
                change={e => this.setState({ callData: {...this.state.callData, name: e} })} />
            </Row>

            <Row width={100}>
              <Input
                placeholder='Telefon *'
                value={this.state.callData.phone}
                change={e => this.setState({ callData: {...this.state.callData, phone: e} })} />
            </Row>

            <Row width={100}>
              <select onChange={(shop) => this.selectShop(shop.target.value)}>
                <option>Välj anläggning *</option>
                {this.props.shops.map(shop =>
                  <option key={shop.id} value={shop.name + ', ' + shop.email}>
                    {shop.name + ', ' + shop.address}
                  </option>
                )}
              </select>
            </Row>

            <Row width={100}>
              <TextArea
                placeholder='Meddelande'
                value={this.state.callData.message}
                change={e => this.setState({ callData: {...this.state.callData, message: e} })} />
            </Row>

            <Row width={100}>
              <CheckBox
                title={this.props.gdprText + ' *'}
                checked={this.state.consent}
                change={e => this.setState({ ...this.state, consent: e })} />
            </Row>

            <div className={`inline-error ${this.state.validError ? 'visible' : ''}`}>
              <span>Fyll i alla obligatoriska fält märkta med en asterisk (*).</span></div>

            <div onClick={() => this.validateAndSend()} className='cta-btn primary left-btn'>Skicka</div>
          </>
          :<>
            <div className='call-window-finished'>
              <span><i className='fas fa-check'></i>
                <strong>Tack för ditt meddelande</strong> till vår anläggning i {this.state.callData.shopName}.
               Vi återkommer till dig så fort vi kan.</span></div>
          </>}
      </div>
    );
  }
}

function Row(props: React.PropsWithChildren<{children?: React.ReactNode; width: number}>) {
  return <div className={`form-node-${props.width}`}>{props.children}</div>;
}